// extracted by mini-css-extract-plugin
module.exports = {"header-row":"HeaderRow_header-row__qkn5y","shopping_cart":"HeaderRow_shopping_cart__keK0E"};